import {
  // Login
  LOGIN_REQUEST,
  LOGIN_RESET,

  // Logout
  LOGOUT_REQUEST,

  // User Profile
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  UPDATE_PROFILE_REQUEST,
  RESET_PROFILE_FLAG,

  // Forgot Password
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,

  // Social Login
  SOCIAL_LOGIN_REQUEST,
  SOCIAL_LOGIN_SUCCESS,
  SOCIAL_LOGIN_FAILURE,

  // Reset State
  RESET_AUTH_STATE,
  GET_OTP_REQUEST,
  GET_OTP_PVS_REQUEST,
  SIGNUP_REQUEST,
  GET_USER_DETAILS_REQUEST,
  GET_ADMIN_DASHBOARD_DATA_REQUEST,
  GET_ALL_INVOICES_REQUEST,
} from "../types/auth"

// =========== Login Actions ===========
export const getOTPRequest = data => ({
  type: GET_OTP_REQUEST,
  payload: data,
})

export const getOTPPVSRequest = data => ({
  type: GET_OTP_PVS_REQUEST,
  payload: data,
})

export const loginRequest = data => ({
  type: LOGIN_REQUEST,
  payload: data,
})

export const signupRequest = data => ({
  type: SIGNUP_REQUEST,
  payload: data,
})

export const getUserDetailsRequest = () => ({
  type: GET_USER_DETAILS_REQUEST,
})

export const getAdminDashboardDataRequest = () => ({
  type: GET_ADMIN_DASHBOARD_DATA_REQUEST,
})

export const getAllInvoicesRequest = data => ({
  type: GET_ALL_INVOICES_REQUEST,
  payload: data,
})

export const loginReset = () => ({
  type: LOGIN_RESET,
})

// =========== Logout Actions ===========
export const logoutRequest = () => ({
  type: LOGOUT_REQUEST,
})

// =========== User Profile Actions ===========
export const getUserRequest = () => ({
  type: GET_USER_REQUEST,
})

export const getUserSuccess = user => ({
  type: GET_USER_SUCCESS,
  payload: user,
})

export const getUserFailure = error => ({
  type: GET_USER_FAILURE,
  payload: error,
})

export const updateUserProfile = user => ({
  type: UPDATE_PROFILE_REQUEST,
  payload: { user },
})

export const resetProfileFlag = () => ({
  type: RESET_PROFILE_FLAG,
})

// =========== Forgot Password Actions ===========
export const forgotPasswordRequest = email => ({
  type: FORGOT_PASSWORD_REQUEST,
  payload: { email },
})

export const forgotPasswordSuccess = message => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: message,
})

export const forgotPasswordFailure = error => ({
  type: FORGOT_PASSWORD_FAILURE,
  payload: error,
})

// =========== Social Login Actions ===========
export const socialLoginRequest = (data, history, type) => ({
  type: SOCIAL_LOGIN_REQUEST,
  payload: { data, history, type },
})

export const socialLoginSuccess = user => ({
  type: SOCIAL_LOGIN_SUCCESS,
  payload: user,
})

export const socialLoginFailure = error => ({
  type: SOCIAL_LOGIN_FAILURE,
  payload: error,
})

// =========== Reset State ===========
export const resetAuthState = () => ({
  type: RESET_AUTH_STATE,
})
